import { Box, Typography, Container, Grid, Card, CardMedia, IconButton, Dialog, DialogContent } from '@mui/material';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { Close } from '@mui/icons-material';

const MediaGallery = () => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const images = [
    { src: '/images/gallery1.jpg', title: 'Executive Summit 2025' },
    { src: '/images/gallery2.jpg', title: 'Global Leadership Conference' },
    { src: '/images/gallery3.jpg', title: 'Business Forum Keynote' },
    { src: '/images/gallery4.jpg', title: 'Strategic Partnership Meeting' },
  ];

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  return (
    <Box sx={{ py: 15, background: '#0B0B0B' }}>
      <Container maxWidth="lg">
        <Typography
          variant="subtitle1"
          sx={{ color: '#C8A96B', letterSpacing: 4, mb: 2, textAlign: 'center' }}
        >
          MEDIA GALLERY
        </Typography>

        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            mb: 8,
            fontSize: { xs: '2rem', md: '3rem' },
          }}
        >
          Moments & Milestones
        </Typography>

        <Grid container spacing={3}>
          {images.map((image, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.03 }}
              >
                <Card
                  sx={{
                    cursor: 'pointer',
                    background: '#111',
                    border: '1px solid rgba(200,169,107,0.2)',
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: '#C8A96B',
                    },
                  }}
                  onClick={() => handleOpen(image.src)}
                >
                  <CardMedia
                    component="img"
                    height="200"
                    image={image.src}
                    alt={image.title}
                    sx={{ objectFit: 'cover' }}
                  />
                  <Box sx={{ p: 2 }}>
                    <Typography variant="body2" sx={{ color: '#ccc' }}>
                      {image.title}
                    </Typography>
                  </Box>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="lg"
          PaperProps={{
            sx: {
              background: 'transparent',
              boxShadow: 'none',
            },
          }}
        >
          <DialogContent sx={{ p: 0, position: 'relative' }}>
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                top: 10,
                right: 10,
                background: 'rgba(0,0,0,0.5)',
                color: '#fff',
                '&:hover': { background: 'rgba(0,0,0,0.8)' },
              }}
            >
              <Close />
            </IconButton>
            <img
              src={selectedImage}
              alt="Gallery"
              style={{ maxWidth: '90vw', maxHeight: '80vh' }}
            />
          </DialogContent>
        </Dialog>
      </Container>
    </Box>
  );
};

export default MediaGallery;